import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { ArrowUpRight, Sparkles } from "lucide-react";
import BeforeAfter from "@/components/BeforeAfter";
import { api, fileUrl } from "@/lib/api";
import { useT } from "@/context/ContentContext";
import { FALLBACK_TRANSFORMACOES } from "./HomeData";

export default function HomeTransformacoes() {
    const t = useT();
    const [transformacoes, setTransformacoes] = useState(FALLBACK_TRANSFORMACOES);

    useEffect(() => {
        api.get("/before-after").then((r) => {
            if (r.data?.length) {
                setTransformacoes(r.data.map((it) => ({
                    title: it.title,
                    subtitle: it.subtitle,
                    before: fileUrl(it.before_id),
                    after: fileUrl(it.after_id),
                })));
            }
        }).catch(() => {});
    }, []);

    return (
        <section className="py-16 sm:py-24 bg-white">
            <div className="max-w-6xl mx-auto px-6 sm:px-10">
                <div className="flex flex-wrap items-end justify-between gap-6 mb-10">
                    <div>
                        <div className="eyebrow mb-6"><Sparkles className="w-3.5 h-3.5" /> {t("home.transf.eyebrow", "Transformações")}</div>
                        <h2 className="font-display text-3xl sm:text-5xl font-bold tracking-tight leading-[1.05] max-w-2xl">
                            {t("home.transf.title", "Antes &")} <span className="font-serif-italic text-[hsl(var(--copper))]">{t("home.transf.title_accent", "depois")}</span><span className="text-[hsl(var(--copper))]">.</span>
                        </h2>
                        <p className="text-[hsl(var(--graphite))]/70 text-lg mt-5 max-w-2xl">
                            {t("home.transf.subtitle", "Arraste o cursor sobre a imagem — ou use as setas — para ver a mudança em algumas das obras realizadas.")}
                        </p>
                    </div>
                    <Link to="/trabalhos" className="btn-outline-dark">
                        {t("home.transf.cta", "Ver mais transformações")}
                        <span className="arrow-circle"><ArrowUpRight className="w-3.5 h-3.5" /></span>
                    </Link>
                </div>
                <div className="w-full max-w-3xl mx-auto rounded-2xl overflow-hidden">
                    {transformacoes[0] && (
                        <BeforeAfter before={transformacoes[0].before} after={transformacoes[0].after} alt={transformacoes[0].title} />
                    )}
                </div>
            </div>
        </section>
    );
}
